







import {apiV1AdminInterviewPath, apiV1AdminInterviewsPath} from '@/rails/routes'
import {Component} from 'vue-property-decorator'
import PostForm from '@/components/admin/PostForm.vue'
import PostNew from '@/components/admin/PostNew'
import Post, {IPost} from '@/models/Post'
import Interview, {IInterview} from '@/models/Interview'
import AddinForm from '@/components/admin/interviews/AddinForm.vue'
import {BreadCrumb} from '@/pages/page-base'

@Component({
  components: {
    PostForm,
    AddinForm
  }
})
export default class InterviewNew extends PostNew {
  path = 'interviews'
  createPath = apiV1AdminInterviewsPath()

  async mounted(): Promise<void> {
    this.targetPath = apiV1AdminInterviewPath('new')
    return super.mounted()
  }

  toFrontModel(data: IPost): Post {
    return new Interview(data as IInterview)
  }

  get breadcrumbs(): Array<BreadCrumb> {
    return [
      {
        text: 'インタビュー一覧',
        to: '/admin/interviews',
        exact: true
      },
      {
        text: 'インタビュー新規作成'
      }
    ]
  }
}
